import { useEffect } from 'react';
import type { MarketAreasResponse } from 'src/apis/storage/types';
import type { StorageServiceRootRequest } from 'src/apis/storage/use-storage-service-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  storageServiceRoot: StorageServiceRootRequest;
};

type ExecuteOptions = {
  url: string;
};

export function usePublicMarketAreas({ storageServiceRoot }: HookOptions) {
  const marketAreas = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<MarketAreasResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!storageServiceRoot.response) return;
    marketAreas.execute({
      // the link is guaranteed to be present in root response
      url: storageServiceRoot.response.data._links!.getFilterMarketAreasPublic
        .href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [storageServiceRoot.response]);

  return marketAreas;
}

export type PublicMarketAreasRequest = ReturnType<typeof usePublicMarketAreas>;
